var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex row align-center",staticStyle:{"height":"60px"}},[_c('v-spacer'),_vm._v(" © milaboratories.com ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }